/*
    Mount and unmount event listeners when app is mounted or unmounted
    Dragevent, dragover and drop are the event listeners that are triggered when draging a file to the dropzone. https://stackoverflow.com/questions/6756583/prevent-browser-from-loading-a-drag-and-dropped-file
*/
export function mountLimitFileDropArea() {
    window.addEventListener('dragenter', eventHandler, false);
    window.addEventListener('dragover', eventHandler);
    window.addEventListener('drop', eventHandler);
}

export function unmountLimitFileDropArea() {
    window.removeEventListener('dragenter', eventHandler, false);
    window.removeEventListener('dragover', eventHandler);
    window.removeEventListener('drop', eventHandler);
}
/*
    effectAllowed: 'property specifies the effect that is allowed for a drag operation'. 'none' means that is not allowed. https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/effectAllowed
    dropEffect: 'property controls the feedback (typically visual) the user is given during a drag and drop operation'. 'none' means that is not allowed. https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/dropEffect
*/
function eventHandler(e: any) {
    e.preventDefault();
    e.dataTransfer.effectAllowed = 'none';
    e.dataTransfer.dropEffect = 'none';
}
